import React from 'react';
import { Link, isRouteErrorResponse, useRouteError } from 'react-router-dom';

const CSS = require('./RouteErrorBoundary.module.scss');

function getMessage(error: unknown): { title: string; detail?: string } {
  if (isRouteErrorResponse(error)) {
    const err = error;
    const title = `${err.status} ${err.statusText}`;
    const detail = typeof err.data === 'string' ? err.data : undefined;
    return { title, detail };
  }
  if (error instanceof Error) {
    return { title: error.message, detail: error.stack };
  }
  try {
    return { title: JSON.stringify(error) };
  } catch {
    return { title: 'Unknown error' };
  }
}

const RouteErrorBoundary: React.FC = () => {
  const error = useRouteError();
  const { title, detail } = getMessage(error);

  return (
    <div className={CSS.Container}>
      <h1 className={CSS.Title}>Something went wrong</h1>
      <p className={CSS.Message}>{title}</p>
      {detail && <pre className={CSS.Detail}>{detail}</pre>}
      <div className={CSS.Actions}>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className={CSS.ReloadButton}
        >
          Reload
        </button>
        <Link to="/" className={CSS.HomeLink}>
          Go to home
        </Link>
      </div>
    </div>
  );
};

export default RouteErrorBoundary;
